import React from 'react';
import { backgroundImageType } from 'types';
import reactHtmlParser from 'react-html-parser';
import * as Modules from 'components/modules';
import T from 'prop-types';
import styles from './noteSection.css';
import * as s from './styled';

const NoteSection = ({
  title,
  colors,
  height,
  textHorizAlign,
  backgroundImage: {
    mobile: backgroundImageMobile,
    desktop: backgroundImageDesktop,
  },
}) => {
  const isBackgroundImagePresent = !!(
    backgroundImageMobile.src || backgroundImageDesktop.src
  );
  const textHorizAlignChecked = textHorizAlign === '' ? 'left' : textHorizAlign;
  return (
    <s.Section height={height}>
      <div
        style={{
          backgroundColor: colors.background,
        }}
        className={!isBackgroundImagePresent ? styles.overlay : undefined}
      />
      {isBackgroundImagePresent && (
        <s.BackgroundOverlay
          backgroundColor={colors.background}
          backgroundImageDesktop={backgroundImageDesktop}
          backgroundImageMobile={backgroundImageMobile}
        />
      )}
      <s.Title textHorizAlign={textHorizAlignChecked} className={styles.title}>
        <span className={styles.titleString}>{reactHtmlParser(title)}</span>
      </s.Title>
    </s.Section>
  );
};

NoteSection.defaultProps = {
  height: null,
  backgroundImage: {
    desktop: {
      src: false,
      backgroundRepeat: false,
      backgroundPosition: false,
      backgroundSize: false,
      backgroundOpacity: false,
    },
    mobile: {
      src: false,
      backgroundRepeat: false,
      backgroundPosition: false,
      backgroundSize: false,
      backgroundOpacity: false,
    },
  },
};

NoteSection.propTypes = {
  title: T.string.isRequired,
  colors: T.shape({
    background: T.string,
    title: T.string,
    titleBackground: T.string,
  }).isRequired,
  height: T.string,
  textHorizAlign: T.string.isRequired,
  backgroundImage: T.shape({
    desktop: backgroundImageType,
    mobile: backgroundImageType,
  }),
};

export default NoteSection;



// WEBPACK FOOTER //
// ./src/components/modules/NoteSection/NoteSection.js